<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import "../node_modules/@fortawesome/fontawesome-free/js/all.js";
import "../node_modules/bootstrap/dist/js/bootstrap";
export default {};
</script>

<style lang="scss">
@import "./assets/styles/custom.scss";
@import "../node_modules/bootstrap/scss/bootstrap.scss";
@import url("https://fonts.googleapis.com/css2?family=Montserrat&display=swap");
* {
  font-family: "Montserrat", sans-serif;
}
</style>
